import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { Location } from '@angular/common';
 
@Injectable()
export class CanDeactivateGuard implements CanDeactivate<any> {

  constructor(
    private readonly location: Location,
    private readonly router: Router
) {}

canDeactivate(component: any, currentRoute: ActivatedRouteSnapshot): boolean {
  console.log('Calling canDeactivate function. Component: ', component);
  
    if (component.canDeactivate) {
        const currentUrlTree = this.router.createUrlTree([], currentRoute);
        console.log('Current URL tree: ', currentUrlTree);
        
        const currentUrl = currentUrlTree.toString();
        console.log('Current url: ', currentUrl);
        
        this.location.go(currentUrl);
        return component.canDeactivate();
    } else {
        return true;
    }
}
  
}
